var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReplace = function SvgReplace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "17px",
    viewBox: "0 0 22 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-497.000000, -687.000000)",
    fill: "#1DBADF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(497.000000, 687.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.6451613,6.08823529 C8.76314516,6.08823529 7.25806452,7.60323176 7.25806452,9.49764706 C7.25806452,11.3920624 8.76314516,12.9070588 10.6451613,12.9070588 C12.5271774,12.9070588 14.0322581,11.3920624 14.0322581,9.49764706 C14.0322581,7.60323176 12.5271774,6.08823529 10.6451613,6.08823529 L10.6451613,6.08823529 Z M10.6451613,4.14 C13.5733065,4.14 15.9677419,6.55021059 15.9677419,9.49764706 C15.9677419,12.4450835 13.5733065,14.8552941 10.6451613,14.8552941 C7.71701613,14.8552941 5.32258065,12.4450835 5.32258065,9.49764706 C5.32258065,6.55021059 7.71701613,4.14 10.6451613,4.14 L10.6451613,4.14 Z M7.74193548,0 L6.53225806,2.43529412 L1.69354839,2.43529412 C0.755322581,2.43529412 0,3.19559294 0,4.14 L0,14.8552941 C0,15.7997012 0.755322581,16.56 1.69354839,16.56 L19.5967742,16.56 C20.535,16.56 21.2903226,15.7997012 21.2903226,14.8552941 L21.2903226,4.14 C21.2903226,3.19559294 20.535,2.43529412 19.5967742,2.43529412 L14.7580645,2.43529412 L13.5483871,0 L7.74193548,0 Z"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReplace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/replace.1a60f959.svg";
export { ForwardRef as ReactComponent };